;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"61edc7a89bb515d236b1a2db5d33c87dcd73cb26"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import { initSentry } from "./sentry.config"
import {
  browserTracingIntegration,
  browserProfilingIntegration,
  thirdPartyErrorFilterIntegration,
} from "@sentry/nextjs"

initSentry({
  integrations: [
    browserTracingIntegration(),
    browserProfilingIntegration(),
    thirdPartyErrorFilterIntegration({
      behaviour: "drop-error-if-contains-third-party-frames",
      filterKeys: ["paragraph-nextjs"],
    }),
  ],
  tracePropagationTargets: ["paragraph.com/api", "api.paragraph.com"],
})
